<template style="font-family: IRANSans">
  <div class="wrapper">
    <!-- data Table -->
    <div v-if="showPage">
      <CRow>
        <CCol col="12" xl="12">
          <CCard class="p-0">
            <CCardHeader
              class="d-flex justify-content-between align-items-center bg-secondary"
            >
              <h5 class="text-light m-0 p-0">نقاط</h5>
              <!-- <CRow class="col-sm-7 col-md-5 col-lg-3"> -->
              <CButton
                color="light"
                @click="
                  addModal = true;
                  modalTitle = 'افزودن نقطه';
                  modalButtonSubmit = 'ثبت';
                  //GetOrganizationalStructureTree();
                  restoreDefault();
                  showMap();
                "
                class="mr-1"
              >
                <CIcon name="cil-plus" /> افزودن
              </CButton>
              <!-- <CButton
                  color="warning"
                  @click="reportPage('pointList')"
                  class="mr-1 col"
                >
                  <CIcon name="cil-print" /> گزارش
                </CButton> -->
              <!-- </CRow> -->
            </CCardHeader>
            <CCardBody class="m-0 p-0">
              <CCard>
                <CButton
                  block
                  class="text-right shadow-none bg-warning card-header"
                  @click="showFilter = showFilter === 6 ? false : 6"
                >
                  <h5 class="text-primary">
                    <CIcon
                      :name="
                        showFilter == 0
                          ? 'cil-chevron-bottom'
                          : 'cil-chevron-top'
                      "
                    />
                    فیلتر
                  </h5>
                </CButton>
                <CCollapse :show="showFilter === 6">
                  <CCardBody>
                    <CRow>
                      <v-jstree
                        class="my-2"
                        :data="structureListFillter"
                        show-checkbox
                        allow-batch
                        whole-row
                        noDots
                        allow-empty
                        @item-click="setFillter"
                      ></v-jstree>
                    </CRow>
                    <!-- <CRow>
                      <CButton
                        @click="getAlarms()"
                        class="
                          mt-4
                          mb-3
                          btn-success
                          col-12
                        "
                        ><CIcon
                          name="cil-check-circle"
                          class="text-light align-self-center"
                      /></CButton>
                    </CRow> -->
                  </CCardBody>
                </CCollapse>
              </CCard>
              <div id="app">
                <!-- <link
                  href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"
                  rel="stylesheet"
                  integrity="sha384-wvfXpqpZZVQGK6TAh5PVlGOfQNHSoD2xbE+QkPxCAFlNEevoEH3Sl0sibVcOQVnN"
                  crossorigin="anonymous"
                /> -->
                <main>
                  <data-table
                    v-bind="parametersTable"
                    @actionTriggered="handleAction"
                  />
                </main>
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </div>

    <!----------------------------------------------------------------------- create and edit point modal -->
    <CModal
      :title="modalTitle"
      :show.sync="addModal"
      size="xl"
      :close-on-backdrop="false"
    >
      <CForm class="needs-validation" novalidate>
        <CAlert color="warning" closeButton :show.sync="alert">
          {{ alertText }}
        </CAlert>

        <CRow>
          <CCol>
            <CRow>
              <CInput
                class="col-sm-12 col-lg-6"
                label="نام"
                v-model="info.name"
                required
                :value="info.name"
              />
              <div class="col-sm-12 col-lg-6">
                <label class="typo__label">لایه</label>
                <multiselect
                  class="needs-validation"
                  v-model="info.LayerValue"
                  :options="LayerList"
                  :searchable="true"
                  :allow-empty="false"
                  :close-on-select="true"
                  :show-labels="false"
                  placeholder="انتخاب..."
                  label="label"
                  track-by="value"
                  :disabled="disableMultiselect"
                ></multiselect>
              </div>

              <div class="col-sm-12 col-lg-6 form-group">
                <label class="typo__label">وضعیت</label>
                <multiselect
                  class="needs-validation"
                  v-model="info.status"
                  :options="StatusList"
                  :allow-empty="false"
                  :searchable="true"
                  :close-on-select="true"
                  :show-labels="false"
                  placeholder="انتخاب..."
                  label="label"
                  track-by="value"
                  :disabled="disableMultiselect"
                ></multiselect>
              </div>

              <CInput
                class="col-sm-12 col-lg-6"
                label="شعاع محدوده"
                v-model="info.radius"
                type="number"
                :value="info.radius"
              />

              <CInput
                class="col-sm-12 col-lg-6"
                label="اولویت"
                v-model="info.pariority"
                type="number"
                :value="info.pariority"
              />

              <div />

              <div class="col-sm-12 col-lg-6 form-group">
                <CButton
                  color="info"
                  class="col-12 rounded d-flex justify-content-between"
                  @click="show_icon = !show_icon"
                >
                  آیکن <i :class="selectedIcon" aria-hidden="true"></i
                ></CButton>
              </div>
              <CRow v-if="show_icon">
                <CInput
                  class="col-12 m-2"
                  placeholder="جستجو..."
                  required
                  v-model="searchIconValue"
                  :value="searchIconValue"
                  @input="searchIcon(searchIconValue)"
                />
                <i
                  v-for="(item, i) in is_search_icon
                    ? filteredListIcon
                    : iconList"
                  :key="i"
                  :class="'fa ' + item.value"
                  class="col-1 m-2"
                  aria-hidden="true"
                  @click="
                    show_icon = !show_icon;
                    selectedIcon = item.value;
                    setIcon(item);
                  "
                ></i>
              </CRow>
            </CRow>

            <h6 class="text-secondary my-2">انتخاب سازمان</h6>
            <v-jstree
              :data="structureList"
              show-checkbox
              allow-batch
              whole-row
              noDots
              @item-click="itemClick"
            ></v-jstree>
          </CCol>
          <CCol>
            <CRow
              ><l-map
                style="height: 450px"
                :zoom="zoom"
                :center="center"
                ref="limitMap"
                @click="getLatLong($event)"
              >
                <l-control-layers position="bottomleft"></l-control-layers>
                <l-tile-layer
                  v-for="tileProvider in tileProviders"
                  :key="tileProvider.name"
                  :name="tileProvider.name"
                  :visible="tileProvider.visible"
                  :url="tileProvider.url"
                  :attribution="tileProvider.attribution"
                  layer-type="base"
                />

                <l-marker :lat-lng="markerLatLng">
                  <l-icon>
                    <span style="font-size: 30px"
                      ><i class="fa fa-map-marker" aria-hidden="true"></i>
                    </span>
                  </l-icon>
                </l-marker>

                <l-control
                  position="topright"
                  class="align-items-center justify-content-center"
                >
                  <CRow class="mx-2">
                    <CInput
                      class="col-5 p-0 m-0"
                      style="direction: ltr"
                      :disabled="true"
                      :placeholder="'lng: ' + markerLatLng[1]"
                      :value="markerLatLng[1]"
                      v-model="markerLatLng[1]"
                      @input="changeLocation($event, 'lng')"
                    ></CInput>

                    <CInput
                      class="col-5 p-0 m-0"
                      style="direction: ltr"
                      :disabled="true"
                      :placeholder="'lat: ' + markerLatLng[0]"
                      :value="markerLatLng[0]"
                      v-model="markerLatLng[0]"
                      @input="changeLocation($event, 'lat')"
                    >
                    </CInput>
                  </CRow>
                </l-control> </l-map
            ></CRow>
          </CCol>
        </CRow>

        <br />
        <CTextarea
          label="توضیحات"
          placeholder="Content..."
          rows="5"
          v-model="info.description"
        />
      </CForm>

      <template #footer>
        <CButton
          v-if="modalButtonSubmit == 'تایید'"
          @click="addModal = false"
          color="success"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />تایید</CButton
        >
        <CButton
          v-if="modalButtonSubmit != 'تایید'"
          @click="addModal = false"
          color="danger"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-ban" class="mx-2" />لغو</CButton
        >
        <CButton
          v-if="modalButtonSubmit != 'تایید'"
          @click="submitForm"
          color="success"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" class="mx-2" />{{
            modalButtonSubmit
          }}</CButton
        >
      </template>
    </CModal>

    <!----------------------------------------------------------------------- Alert modal -->
    <CModal
      :title="alertModalTitle"
      :color="alertModalColor"
      :show.sync="alertModal"
    >
      {{ alertModalText }}

      <template #footer>
        <CButton
          v-if="alertModalTitle != 'حذف نقطه'"
          @click="alertModal = false"
          :color="alertModalColor"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" class="mx-1" />{{
            alertModalButtonText
          }}</CButton
        >
        <CButton
          v-if="alertModalTitle == 'حذف نقطه'"
          @click="deletePoint"
          :color="alertModalColor"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" class="mx-1" />{{
            alertModalButtonText
          }}</CButton
        >
      </template>
    </CModal>
  </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="css">
.table-wrapper {
  height: 60vh !important;
}
</style>

<script>
import axios from "axios";
import { Values } from "../../../src/commonValues";
import vMultiselectListbox from "vue-multiselect-listbox";
import $ from "jquery";
import Multiselect from "vue-multiselect";
import router from "../../router";
import VJstree from "vue-jstree-master"; //rtl
import VueClockPicker from "@pencilpix/vue2-clock-picker";

import {
  LMap,
  LTileLayer,
  LMarker,
  LTooltip,
  LControlLayers,
  LIcon,
  LControl,
} from "vue2-leaflet";

import "babel-polyfill";

export default {
  name: "Modals",

  components: {
    VueClockPicker,
    vMultiselectListbox,
    Multiselect,
    VJstree,
    LMap,
    LTileLayer,
    LMarker,
    LTooltip,
    LControlLayers,
    LIcon,
    LControl,
  },

  data() {
    return {
      fillterActive: false,
      showFilter: 0,
      structureListFillter: [],
      pointsFelltered: [],
      alarmMinMax: [],
      showAlarm: 1,

      tileProviders: Values.tileProviders,
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 6,
      center: [33.504, 51.26],
      markerLatLng: [33.504, 51.26],

      addModal: false,
      assignModal: false,
      settingModalFda: false,
      settingModalTracking: false,
      settingModalTracking2: false,
      settingModalTrackingJahad: false,
      settingModalIch: false,
      settingModalFE22WE: false,
      settingModalFreezEyeV3: false,
      settingModalLog: false,
      points: [],
      modalTitle: "",
      modalButtonSubmit: "",

      alertModal: false,
      alertModalTitle: "",
      alertModalText: "",
      alertModalButtonText: "",
      alertModalColor: "",
      pointId: "",

      smsModal: false,
      settingModal: false,
      smsSettingInfo: {
        phoneNumber: "",
        timeMaxTemp: "",
        timeMinTemp: "",
        timeMaxHum: "",
        timeMinHum: "",
        timeDisPower: "",
        timeDisSensor: "",
        reception: {
          value: "1",
          label: "گیرنده اول",
        },
        receptionTemp: {
          value: "1",
          label: "گیرنده اول",
        },
        receptionHum: {
          value: "1",
          label: "گیرنده اول",
        },
        active: false,
        textSms: false,
        puls: false,
      },
      receptionList: [
        {
          value: "1",
          label: "گیرنده اول",
        },
        {
          value: "2",
          label: "گیرنده دوم",
        },
        {
          value: "3",
          label: "گیرنده سوم",
        },
        {
          value: "4",
          label: "گیرنده چهارم",
        },
        {
          value: "5",
          label: "گیرنده پنجم",
        },
        {
          value: "6",
          label: "گیرنده ششم",
        },
      ],

      detectedCarModal: false,
      detectedCarModalTitle: "",
      detectedCarModalText: "",
      detectedCarModalButtonText: "",
      detectedCarModalColor: "",
      detectedCarModalStatus: true,
      detectedCarModalInfo: Object,

      info: {
        id: "",
        name: "",
        status: { label: "فعال", value: 1 },
        description: "",
        LayerValue: [{ label: "", value: "" }],
        radius:"",
        pariority:"",
      },

      startDelayUpdateTime: "---",

      simcard: {
        simCardNum: "",
        sendSmsStatus: false,
        simcardDataStatus: false,
        updateTime: "---",
      },

      wifi: {
        ipAddress: "",
        subnetMask: "",
        gateway: "",
        dns: "",
        ssid: "",
        password: "",
        active: false,
        updateTime: "---",
      },

      ethernet: {
        ipAddress: "",
        subnetMask: "",
        gateway: "",
        dns: "",
        updateTime: "---",
      },

      serverInfo: {
        ipAddressGPRS: "",
        ipAddressWiFi: "",
        ipAddressEthernet: "",
        port: "",
        timeDistance: "",
        debugSystem: false,
        debugGsm: false,
        debugWifi: false,

        wifi: false,
        ethernet: false,
        gprs: false,
        updateTime: "---",
      },

      smsReception: {
        first: "",
        second: "",
        third: "",
        forth: "",
        fifth: "",
        sixth: "",
        updateTime: "---",
      },

      voiceAlarmInfo: {
        delay: "",
        length: "",
        voiceTemp: false,
        smsTemp: false,
        voiceHum: false,
        smsHum: false,
        updateTime: "---",
      },

      serial: { serialTime: "", serialNumber: "" },

      SmsCost: {
        sendTime: "",
        cost: "",
      },

      pulsInfo: {
        first: "",
        second: "",
        updateTime: "---",
      },

      dateTime: { dateTime: "", updateTime: "" },

      StatusList: [
        {
          value: 1,
          label: "فعال",
        },
        {
          value: 0,
          label: "غیرفعال",
        },
      ],

      SimcardOprator: [],
      simcardUpdateTime: "---",

      SimcardType: [],

      groupName: "",
      disableMultiselect: false,

      LayerList: [],

      sensorModal: false,
      SensorList: [
        {
          serialNumber: "",
          carSensorTypes: [],
        },
      ],

      alert: false,
      alertText: "",
      showPage: true,

      structureList: [],
      selectedParent: "",

      settingValues: [],
      settingValuesSensor: [],

      fullData: [],
      indexListSensor: [],

      indexValueSensor: { label: "", value: "" },
      sensorUpdateTime: "---",

      typeValue: [],
      selectedSensors: [],
      activeSensor: false,

      iconList: [
        { value: "fa-align-left", label: "fa-align-left" },
        { value: "fa-align-right", label: "fa-align-right" },
        { value: "fa-amazon", label: "fa-amazon" },
        { value: "fa-ambulance", label: "fa-ambulance" },
        { value: "fa-anchor", label: "fa-anchor" },
        { value: "fa-android", label: "fa-android" },
        { value: "fa-angellist", label: "fa-angellist" },
        { value: "fa-angle-double-down", label: "fa-angle-double-down" },
        { value: "fa-angle-double-left", label: "fa-angle-double-left" },
        { value: "fa-angle-double-right", label: "fa-angle-double-right" },
        { value: "fa-angle-double-up", label: "fa-angle-double-up" },
        { value: "fa-angle-left", label: "fa-angle-left" },
        { value: "fa-angle-right", label: "fa-angle-right" },
        { value: "fa-angle-up", label: "fa-angle-up" },
        { value: "fa-apple", label: "fa-apple" },
        { value: "fa-archive", label: "fa-archive" },
        { value: "fa-area-chart", label: "fa-area-chart" },
        { value: "fa-arrow-circle-down", label: "fa-arrow-circle-down" },
        { value: "fa-arrow-circle-left", label: "fa-arrow-circle-left" },
        { value: "fa-arrow-circle-o-down", label: "fa-arrow-circle-o-down" },
        { value: "fa-arrow-circle-o-left", label: "fa-arrow-circle-o-left" },
        { value: "fa-arrow-circle-o-right", label: "fa-arrow-circle-o-right" },
        { value: "fa-arrow-circle-o-up", label: "fa-arrow-circle-o-up" },
        { value: "fa-arrow-circle-right", label: "fa-arrow-circle-right" },
        { value: "fa-arrow-circle-up", label: "fa-arrow-circle-up" },
        { value: "fa-arrow-down", label: "fa-arrow-down" },
        { value: "fa-arrow-left", label: "fa-arrow-left" },
        { value: "fa-arrow-right", label: "fa-arrow-right" },
        { value: "fa-arrow-up", label: "fa-arrow-up" },
        { value: "fa-arrows", label: "fa-arrows" },
        { value: "fa-arrows-alt", label: "fa-arrows-alt" },
        { value: "fa-arrows-h", label: "fa-arrows-h" },
        { value: "fa-arrows-v", label: "fa-arrows-v" },
        { value: "fa-asterisk", label: "fa-asterisk" },
        { value: "fa-at", label: "fa-at" },
        { value: "fa-automobile", label: "fa-automobile" },
        { value: "fa-backward", label: "fa-backward" },
        { value: "fa-balance-scale", label: "fa-balance-scale" },
        { value: "fa-ban", label: "fa-ban" },
        { value: "fa-bank", label: "fa-bank" },
        { value: "fa-bar-chart", label: "fa-bar-chart" },
        { value: "fa-bar-chart-o", label: "fa-bar-chart-o" },
        { value: "fa-battery-full", label: "fa-battery-full" },
        { value: "fa-beer", label: "fa-beer" },
        { value: "fa-behance", label: "fa-behance" },
        { value: "fa-behance-square", label: "fa-behance-square" },
        { value: "fa-bell", label: "fa-bell" },
        { value: "fa-bell-o", label: "fa-bell-o" },
        { value: "fa-bell-slash", label: "fa-bell-slash" },
        { value: "fa-bell-slash-o", label: "fa-bell-slash-o" },
        { value: "fa-bicycle", label: "fa-bicycle" },
        { value: "fa-binoculars", label: "fa-binoculars" },
        { value: "fa-birthday-cake", label: "fa-birthday-cake" },
        { value: "fa-bitbucket", label: "fa-bitbucket" },
        { value: "fa-bitbucket-square", label: "fa-bitbucket-square" },
        { value: "fa-bitcoin", label: "fa-bitcoin" },
        { value: "fa-black-tie", label: "fa-black-tie" },
        { value: "fa-bold", label: "fa-bold" },
        { value: "fa-bolt", label: "fa-bolt" },
        { value: "fa-bomb", label: "fa-bomb" },
        { value: "fa-book", label: "fa-book" },
        { value: "fa-bookmark", label: "fa-bookmark" },
        { value: "fa-bookmark-o", label: "fa-bookmark-o" },
        { value: "fa-briefcase", label: "fa-briefcase" },
        { value: "fa-btc", label: "fa-btc" },
        { value: "fa-bug", label: "fa-bug" },
        { value: "fa-building", label: "fa-building" },
        { value: "fa-building-o", label: "fa-building-o" },
        { value: "fa-bullhorn", label: "fa-bullhorn" },
        { value: "fa-bullseye", label: "fa-bullseye" },
        { value: "fa-bus", label: "fa-bus" },
        { value: "fa-cab", label: "fa-cab" },
        { value: "fa-calendar", label: "fa-calendar" },
        { value: "fa-camera", label: "fa-camera" },
        { value: "fa-car", label: "fa-car" },
        { value: "fa-caret-up", label: "fa-caret-up" },
        { value: "fa-cart-plus", label: "fa-cart-plus" },
        { value: "fa-cc", label: "fa-cc" },
        { value: "fa-cc-amex", label: "fa-cc-amex" },
        { value: "fa-cc-jcb", label: "fa-cc-jcb" },
        { value: "fa-cc-paypal", label: "fa-cc-paypal" },
        { value: "fa-cc-stripe", label: "fa-cc-stripe" },
        { value: "fa-cc-visa", label: "fa-cc-visa" },
        { value: "fa-chain", label: "fa-chain" },
        { value: "fa-check", label: "fa-check" },
        { value: "fa-chevron-left", label: "fa-chevron-left" },
        { value: "fa-chevron-right", label: "fa-chevron-right" },
        { value: "fa-chevron-up", label: "fa-chevron-up" },
        { value: "fa-child", label: "fa-child" },
        { value: "fa-chrome", label: "fa-chrome" },
        { value: "fa-circle", label: "fa-circle" },
        { value: "fa-circle-o", label: "fa-circle-o" },
        { value: "fa-circle-o-notch", label: "fa-circle-o-notch" },
        { value: "fa-circle-thin", label: "fa-circle-thin" },
        { value: "fa-clipboard", label: "fa-clipboard" },
        { value: "fa-clock-o", label: "fa-clock-o" },
        { value: "fa-clone", label: "fa-clone" },
        { value: "fa-close", label: "fa-close" },
        { value: "fa-cloud", label: "fa-cloud" },
        { value: "fa-cloud-download", label: "fa-cloud-download" },
        { value: "fa-cloud-upload", label: "fa-cloud-upload" },
        { value: "fa-cny", label: "fa-cny" },
        { value: "fa-code", label: "fa-code" },
        { value: "fa-code-fork", label: "fa-code-fork" },
        { value: "fa-codepen", label: "fa-codepen" },
        { value: "fa-coffee", label: "fa-coffee" },
        { value: "fa-cog", label: "fa-cog" },
        { value: "fa-cogs", label: "fa-cogs" },
        { value: "fa-columns", label: "fa-columns" },
        { value: "fa-comment", label: "fa-comment" },
        { value: "fa-comment-o", label: "fa-comment-o" },
        { value: "fa-commenting", label: "fa-commenting" },
        { value: "fa-commenting-o", label: "fa-commenting-o" },
        { value: "fa-comments", label: "fa-comments" },
        { value: "fa-comments-o", label: "fa-comments-o" },
        { value: "fa-compass", label: "fa-compass" },
        { value: "fa-compress", label: "fa-compress" },
        { value: "fa-connectdevelop", label: "fa-connectdevelop" },
        { value: "fa-contao", label: "fa-contao" },
        { value: "fa-copy", label: "fa-copy" },
        { value: "fa-copyright", label: "fa-copyright" },
        { value: "fa-creative-commons", label: "fa-creative-commons" },
        { value: "fa-credit-card", label: "fa-credit-card" },
        { value: "fa-crop", label: "fa-crop" },
        { value: "fa-crosshairs", label: "fa-crosshairs" },
        { value: "fa-css3", label: "fa-css3" },
        { value: "fa-cube", label: "fa-cube" },
        { value: "fa-cubes", label: "fa-cubes" },
        { value: "fa-cut", label: "fa-cut" },
        { value: "fa-cutlery", label: "fa-cutlery" },
        { value: "fa-dashboard", label: "fa-dashboard" },
        { value: "fa-dashcube", label: "fa-dashcube" },
        { value: "fa-database", label: "fa-database" },
        { value: "fa-dedent", label: "fa-dedent" },
        { value: "fa-delicious", label: "fa-delicious" },
        { value: "fa-desktop", label: "fa-desktop" },
        { value: "fa-deviantart", label: "fa-deviantart" },
        { value: "fa-diamond", label: "fa-diamond" },
        { value: "fa-digg", label: "fa-digg" },
        { value: "fa-dollar", label: "fa-dollar" },
        { value: "fa-download", label: "fa-download" },
        { value: "fa-dribbble", label: "fa-dribbble" },
        { value: "fa-dropbox", label: "fa-dropbox" },
        { value: "fa-drupal", label: "fa-drupal" },
        { value: "fa-edit", label: "fa-edit" },
        { value: "fa-eject", label: "fa-eject" },
        { value: "fa-ellipsis-h", label: "fa-ellipsis-h" },
        { value: "fa-ellipsis-v", label: "fa-ellipsis-v" },
        { value: "fa-empire", label: "fa-empire" },
        { value: "fa-envelope", label: "fa-envelope" },
        { value: "fa-envelope-o", label: "fa-envelope-o" },
        { value: "fa-eur", label: "fa-eur" },
        { value: "fa-euro", label: "fa-euro" },
        { value: "fa-exchange", label: "fa-exchange" },
        { value: "fa-exclamation", label: "fa-exclamation" },
        { value: "fa-exclamation-circle", label: "fa-exclamation-circle" },
        { value: "fa-exclamation-triangle", label: "fa-exclamation-triangle" },
        { value: "fa-expand", label: "fa-expand" },
        { value: "fa-expeditedssl", label: "fa-expeditedssl" },
        { value: "fa-external-link", label: "fa-external-link" },
        { value: "fa-external-link-square", label: "fa-external-link-square" },
        { value: "fa-eye", label: "fa-eye" },
        { value: "fa-eye-slash", label: "fa-eye-slash" },
        { value: "fa-eyedropper", label: "fa-eyedropper" },
        { value: "fa-facebook", label: "fa-facebook" },
        { value: "fa-facebook-f", label: "fa-facebook-f" },
        { value: "fa-facebook-official", label: "fa-facebook-official" },
        { value: "fa-facebook-square", label: "fa-facebook-square" },
        { value: "fa-fast-backward", label: "fa-fast-backward" },
        { value: "fa-fast-forward", label: "fa-fast-forward" },
        { value: "fa-fax", label: "fa-fax" },
        { value: "fa-feed", label: "fa-feed" },
        { value: "fa-female", label: "fa-female" },
        { value: "fa-fighter-jet", label: "fa-fighter-jet" },
        { value: "fa-file", label: "fa-file" },
        { value: "fa-file-archive-o", label: "fa-file-archive-o" },
        { value: "fa-file-audio-o", label: "fa-file-audio-o" },
        { value: "fa-file-code-o", label: "fa-file-code-o" },
        { value: "fa-file-excel-o", label: "fa-file-excel-o" },
        { value: "fa-file-image-o", label: "fa-file-image-o" },
        { value: "fa-file-movie-o", label: "fa-file-movie-o" },
        { value: "fa-file-o", label: "fa-file-o" },
        { value: "fa-file-pdf-o", label: "fa-file-pdf-o" },
        { value: "fa-file-photo-o", label: "fa-file-photo-o" },
        { value: "fa-file-picture-o", label: "fa-file-picture-o" },
        { value: "fa-file-powerpoint-o", label: "fa-file-powerpoint-o" },
        { value: "fa-file-sound-o", label: "fa-file-sound-o" },
        { value: "fa-file-text", label: "fa-file-text" },
        { value: "fa-file-text-o", label: "fa-file-text-o" },
        { value: "fa-file-video-o", label: "fa-file-video-o" },
        { value: "fa-file-word-o", label: "fa-file-word-o" },
        { value: "fa-file-zip-o", label: "fa-file-zip-o" },
        { value: "fa-files-o", label: "fa-files-o" },
        { value: "fa-film", label: "fa-film" },
        { value: "fa-filter", label: "fa-filter" },
        { value: "fa-fire", label: "fa-fire" },
        { value: "fa-fire-extinguisher", label: "fa-fire-extinguisher" },
        { value: "fa-firefox", label: "fa-firefox" },
        { value: "fa-flag", label: "fa-flag" },
        { value: "fa-flag-checkered", label: "fa-flag-checkered" },
        { value: "fa-flag-o", label: "fa-flag-o" },
        { value: "fa-flash", label: "fa-flash" },
        { value: "fa-flask", label: "fa-flask" },
        { value: "fa-flickr", label: "fa-flickr" },
        { value: "fa-floppy-o", label: "fa-floppy-o" },
        { value: "fa-folder", label: "fa-folder" },
        { value: "fa-folder-o", label: "fa-folder-o" },
        { value: "fa-folder-open", label: "fa-folder-open" },
        { value: "fa-folder-open-o", label: "fa-folder-open-o" },
        { value: "fa-font", label: "fa-font" },
        { value: "fa-fonticons", label: "fa-fonticons" },
        { value: "fa-forumbee", label: "fa-forumbee" },
        { value: "fa-forward", label: "fa-forward" },
        { value: "fa-foursquare", label: "fa-foursquare" },
        { value: "fa-frown-o", label: "fa-frown-o" },
        { value: "fa-futbol-o", label: "fa-futbol-o" },
        { value: "fa-gamepad", label: "fa-gamepad" },
        { value: "fa-gavel", label: "fa-gavel" },
        { value: "fa-gbp", label: "fa-gbp" },
        { value: "fa-ge", label: "fa-ge" },
        { value: "fa-gear", label: "fa-gear" },
        { value: "fa-gears", label: "fa-gears" },
        { value: "fa-genderless", label: "fa-genderless" },
        { value: "fa-get-pocket", label: "fa-get-pocket" },
        { value: "fa-gg", label: "fa-gg" },
        { value: "fa-gg-circle", label: "fa-gg-circle" },
        { value: "fa-gift", label: "fa-gift" },
        { value: "fa-git", label: "fa-git" },
        { value: "fa-git-square", label: "fa-git-square" },
        { value: "fa-github", label: "fa-github" },
        { value: "fa-github-alt", label: "fa-github-alt" },
        { value: "fa-github-square", label: "fa-github-square" },
        { value: "fa-gittip", label: "fa-gittip" },
        { value: "fa-glass", label: "fa-glass" },
        { value: "fa-globe", label: "fa-globe" },
        { value: "fa-google", label: "fa-google" },
        { value: "fa-google-plus", label: "fa-google-plus" },
        { value: "fa-google-plus-square", label: "fa-google-plus-square" },
        { value: "fa-google-wallet", label: "fa-google-wallet" },
        { value: "fa-graduation-cap", label: "fa-graduation-cap" },
        { value: "fa-gratipay", label: "fa-gratipay" },
        { value: "fa-group", label: "fa-group" },
        { value: "fa-h-square", label: "fa-h-square" },
        { value: "fa-hacker-news", label: "fa-hacker-news" },
        { value: "fa-hand-grab-o", label: "fa-hand-grab-o" },
        { value: "fa-hand-lizard-o", label: "fa-hand-lizard-o" },
        { value: "fa-hand-o-down", label: "fa-hand-o-down" },
        { value: "fa-hand-o-left", label: "fa-hand-o-left" },
        { value: "fa-hand-o-right", label: "fa-hand-o-right" },
        { value: "fa-hand-o-up", label: "fa-hand-o-up" },
        { value: "fa-hand-paper-o", label: "fa-hand-paper-o" },
        { value: "fa-hand-peace-o", label: "fa-hand-peace-o" },
        { value: "fa-hand-pointer-o", label: "fa-hand-pointer-o" },
        { value: "fa-hand-rock-o", label: "fa-hand-rock-o" },
        { value: "fa-hand-scissors-o", label: "fa-hand-scissors-o" },
        { value: "fa-hand-spock-o", label: "fa-hand-spock-o" },
        { value: "fa-hand-stop-o", label: "fa-hand-stop-o" },
        { value: "fa-hdd-o", label: "fa-hdd-o" },
        { value: "fa-header", label: "fa-header" },
        { value: "fa-headphones", label: "fa-headphones" },
        { value: "fa-heart", label: "fa-heart" },
        { value: "fa-heart-o", label: "fa-heart-o" },
        { value: "fa-heartbeat", label: "fa-heartbeat" },
        { value: "fa-history", label: "fa-history" },
        { value: "fa-home", label: "fa-home" },
        { value: "fa-hospital-o", label: "fa-hospital-o" },
        { value: "fa-hotel", label: "fa-hotel" },
        { value: "fa-hourglass", label: "fa-hourglass" },
        { value: "fa-hourglass-1", label: "fa-hourglass-1" },
        { value: "fa-hourglass-2", label: "fa-hourglass-2" },
        { value: "fa-hourglass-3", label: "fa-hourglass-3" },
        { value: "fa-hourglass-end", label: "fa-hourglass-end" },
        { value: "fa-hourglass-half", label: "fa-hourglass-half" },
        { value: "fa-hourglass-o", label: "fa-hourglass-o" },
        { value: "fa-hourglass-start", label: "fa-hourglass-start" },
        { value: "fa-houzz", label: "fa-houzz" },
        { value: "fa-html5", label: "fa-html5" },
        { value: "fa-i-cursor", label: "fa-i-cursor" },
        { value: "fa-ils", label: "fa-ils" },
        { value: "fa-image", label: "fa-image" },
        { value: "fa-inbox", label: "fa-inbox" },
        { value: "fa-indent", label: "fa-indent" },
        { value: "fa-industry", label: "fa-industry" },
        { value: "fa-info", label: "fa-info" },
        { value: "fa-info-circle", label: "fa-info-circle" },
        { value: "fa-inr", label: "fa-inr" },
        { value: "fa-instagram", label: "fa-instagram" },
        { value: "fa-institution", label: "fa-institution" },
        { value: "fa-internet-explorer", label: "fa-internet-explorer" },
        { value: "fa-intersex", label: "fa-intersex" },
        { value: "fa-ioxhost", label: "fa-ioxhost" },
        { value: "fa-italic", label: "fa-italic" },
        { value: "fa-joomla", label: "fa-joomla" },
        { value: "fa-jpy", label: "fa-jpy" },
        { value: "fa-jsfiddle", label: "fa-jsfiddle" },
        { value: "fa-key", label: "fa-key" },
        { value: "fa-keyboard-o", label: "fa-keyboard-o" },
        { value: "fa-krw", label: "fa-krw" },
        { value: "fa-language", label: "fa-language" },
        { value: "fa-laptop", label: "fa-laptop" },
        { value: "fa-lastfm", label: "fa-lastfm" },
        { value: "fa-lastfm-square", label: "fa-lastfm-square" },
        { value: "fa-leaf", label: "fa-leaf" },
        { value: "fa-leanpub", label: "fa-leanpub" },
        { value: "fa-legal", label: "fa-legal" },
        { value: "fa-lemon-o", label: "fa-lemon-o" },
        { value: "fa-level-down", label: "fa-level-down" },
        { value: "fa-level-up", label: "fa-level-up" },
        { value: "fa-life-bouy", label: "fa-life-bouy" },
        { value: "fa-life-buoy", label: "fa-life-buoy" },
        { value: "fa-life-ring", label: "fa-life-ring" },
        { value: "fa-life-saver", label: "fa-life-saver" },
        { value: "fa-lightbulb-o", label: "fa-lightbulb-o" },
        { value: "fa-line-chart", label: "fa-line-chart" },
        { value: "fa-link", label: "fa-link" },
        { value: "fa-linkedin", label: "fa-linkedin" },
        { value: "fa-linkedin-square", label: "fa-linkedin-square" },
        { value: "fa-linux", label: "fa-linux" },
        { value: "fa-list", label: "fa-list" },
        { value: "fa-list-alt", label: "fa-list-alt" },
        { value: "fa-list-ol", label: "fa-list-ol" },
        { value: "fa-list-ul", label: "fa-list-ul" },
        { value: "fa-location-arrow", label: "fa-location-arrow" },
        { value: "fa-lock", label: "fa-lock" },
        { value: "fa-long-arrow-down", label: "fa-long-arrow-down" },
        { value: "fa-long-arrow-left", label: "fa-long-arrow-left" },
        { value: "fa-long-arrow-right", label: "fa-long-arrow-right" },
        { value: "fa-long-arrow-up", label: "fa-long-arrow-up" },
        { value: "fa-magic", label: "fa-magic" },
        { value: "fa-magnet", label: "fa-magnet" },
        { value: "fa-mars-stroke-v", label: "fa-mars-stroke-v" },
        { value: "fa-maxcdn", label: "fa-maxcdn" },
        { value: "fa-meanpath", label: "fa-meanpath" },
        { value: "fa-medium", label: "fa-medium" },
        { value: "fa-medkit", label: "fa-medkit" },
        { value: "fa-meh-o", label: "fa-meh-o" },
        { value: "fa-mercury", label: "fa-mercury" },
        { value: "fa-microphone", label: "fa-microphone" },
        { value: "fa-mobile", label: "fa-mobile" },
        { value: "fa-motorcycle", label: "fa-motorcycle" },
        { value: "fa-mouse-pointer", label: "fa-mouse-pointer" },
        { value: "fa-music", label: "fa-music" },
        { value: "fa-navicon", label: "fa-navicon" },
        { value: "fa-neuter", label: "fa-neuter" },
        { value: "fa-newspaper-o", label: "fa-newspaper-o" },
        { value: "fa-opencart", label: "fa-opencart" },
        { value: "fa-openid", label: "fa-openid" },
        { value: "fa-opera", label: "fa-opera" },
        { value: "fa-outdent", label: "fa-outdent" },
        { value: "fa-pagelines", label: "fa-pagelines" },
        { value: "fa-paper-plane-o", label: "fa-paper-plane-o" },
        { value: "fa-paperclip", label: "fa-paperclip" },
        { value: "fa-paragraph", label: "fa-paragraph" },
        { value: "fa-paste", label: "fa-paste" },
        { value: "fa-pause", label: "fa-pause" },
        { value: "fa-paw", label: "fa-paw" },
        { value: "fa-paypal", label: "fa-paypal" },
        { value: "fa-pencil", label: "fa-pencil" },
        { value: "fa-pencil-square-o", label: "fa-pencil-square-o" },
        { value: "fa-phone", label: "fa-phone" },
        { value: "fa-photo", label: "fa-photo" },
        { value: "fa-picture-o", label: "fa-picture-o" },
        { value: "fa-pie-chart", label: "fa-pie-chart" },
        { value: "fa-pied-piper", label: "fa-pied-piper" },
        { value: "fa-pied-piper-alt", label: "fa-pied-piper-alt" },
        { value: "fa-pinterest", label: "fa-pinterest" },
        { value: "fa-pinterest-p", label: "fa-pinterest-p" },
        { value: "fa-pinterest-square", label: "fa-pinterest-square" },
        { value: "fa-plane", label: "fa-plane" },
        { value: "fa-play", label: "fa-play" },
        { value: "fa-play-circle", label: "fa-play-circle" },
        { value: "fa-play-circle-o", label: "fa-play-circle-o" },
        { value: "fa-plug", label: "fa-plug" },
        { value: "fa-plus", label: "fa-plus" },
        { value: "fa-plus-circle", label: "fa-plus-circle" },
        { value: "fa-plus-square", label: "fa-plus-square" },
        { value: "fa-plus-square-o", label: "fa-plus-square-o" },
        { value: "fa-power-off", label: "fa-power-off" },
        { value: "fa-print", label: "fa-print" },
        { value: "fa-puzzle-piece", label: "fa-puzzle-piece" },
        { value: "fa-qq", label: "fa-qq" },
        { value: "fa-qrcode", label: "fa-qrcode" },
        { value: "fa-question", label: "fa-question" },
        { value: "fa-question-circle", label: "fa-question-circle" },
        { value: "fa-quote-left", label: "fa-quote-left" },
        { value: "fa-quote-right", label: "fa-quote-right" },
        { value: "fa-ra", label: "fa-ra" },
        { value: "fa-random", label: "fa-random" },
        { value: "fa-rebel", label: "fa-rebel" },
        { value: "fa-recycle", label: "fa-recycle" },
        { value: "fa-reddit", label: "fa-reddit" },
        { value: "fa-reddit-square", label: "fa-reddit-square" },
        { value: "fa-refresh", label: "fa-refresh" },
        { value: "fa-registered", label: "fa-registered" },
        { value: "fa-remove", label: "fa-remove" },
        { value: "fa-renren", label: "fa-renren" },
        { value: "fa-reorder", label: "fa-reorder" },
        { value: "fa-repeat", label: "fa-repeat" },
        { value: "fa-reply", label: "fa-reply" },
        { value: "fa-reply-all", label: "fa-reply-all" },
        { value: "fa-retweet", label: "fa-retweet" },
        { value: "fa-rmb", label: "fa-rmb" },
        { value: "fa-road", label: "fa-road" },
        { value: "fa-rocket", label: "fa-rocket" },
        { value: "fa-rotate-left", label: "fa-rotate-left" },
        { value: "fa-rotate-right", label: "fa-rotate-right" },
        { value: "fa-rouble", label: "fa-rouble" },
        { value: "fa-rss", label: "fa-rss" },
        { value: "fa-rss-square", label: "fa-rss-square" },
        { value: "fa-rub", label: "fa-rub" },
        { value: "fa-ruble", label: "fa-ruble" },
        { value: "fa-rupee", label: "fa-rupee" },
        { value: "fa-safari", label: "fa-safari" },
        { value: "fa-sliders", label: "fa-sliders" },
        { value: "fa-slideshare", label: "fa-slideshare" },
        { value: "fa-smile-o", label: "fa-smile-o" },
        { value: "fa-sort-asc", label: "fa-sort-asc" },
        { value: "fa-sort-desc", label: "fa-sort-desc" },
        { value: "fa-sort-down", label: "fa-sort-down" },
        { value: "fa-spinner", label: "fa-spinner" },
        { value: "fa-spoon", label: "fa-spoon" },
        { value: "fa-spotify", label: "fa-spotify" },
        { value: "fa-square", label: "fa-square" },
        { value: "fa-square-o", label: "fa-square-o" },
        { value: "fa-star", label: "fa-star" },
        { value: "fa-star-half", label: "fa-star-half" },
        { value: "fa-stop", f04d: "fa-stop" },
        { value: "fa-subscript", label: "fa-subscript" },
        { value: "fa-tablet", f10a: "fa-tablet" },
        { value: "fa-tachometer", label: "fa-tachometer" },
        { value: "fa-tag", label: "fa-tag" },
        { value: "fa-tags", label: "fa-tags" },
      ],
      filteredListIcon: [],
      show_icon: false,
      selectedIcon: "fa fa-car",
      searchIconValue: "",
      is_search_icon: false,

      ipformat:
        /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
      mobileFormat: /^(09(0[1-2]|1[0-9]|3[0-9]|2[0-1])-?[0-9]{3}-?[0-9]{4})$/,
      emailFormat: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
    };
  },

  computed: {
    parametersTable() {
      return {
        data:
          this.fillterActive == false ? this.points : this.pointsFelltered,
        actionMode: "multiple",
        // showPerPage:true,
        perPageSizes: [5, 10, 25, 50, 100],
        defaultPerPage: 5,
        columns: [
          {
            key: "rowNumber",
            title: "ردیف",
            sortable: false,
          },
          {
            key: "pointName",
            title: "نام",
          },
          {
            key: "pointCategoryName",
            title: "لایه",
          },

          {
            key: "statusName",
            title: "وضعیت",
          },

          // {
          //   key: "description",
          //   title: "توضیحات",
          // },
        ],
        // actions: [
        //   "view",
        //   "edit",
        //   "delete",
        //
        //   "sms",
        //   "network",
        //   "setting",
        // ],
        //actions: ["view", "edit", "delete", "setting", "sensor", "sms"],
        actions: ["view", "edit", "delete"],
      };
    },
  },

  mounted() {
    this.refreshTable();

    this.GetOrganizationalStructureTree();

    // get model list value from server
    axios
      .get(Values.serverIp + "Point/GetPointTypeSelectList")
      .then((response) => {
        console.log(response.data);
        this.LayerList = response.data;
      });
  },

  methods: {
    changeLocation(data, latLng) {
      if (latLng == "lat") this.markerLatLng[0] = data;
      else this.markerLatLng[1] = data;
      console.log(this.markerLatLng);
    },

    //************************************************************************search icon */
    searchIcon(data) {
      console.log(data);
      if (data.length > 0) {
        this.is_search_icon = true;
        this.filteredListIcon = this.iconList.filter(function (el) {
          return el.value.includes(data);
        });
      } else {
        this.is_search_icon = false;
        this.filteredListIcon = [];
      }
    },
    //************************************************************************ set icon */
    setIcon(data) {
      this.selectedIcon = "fa " + data.value;
      //console.log(this.selectedIcon);
    },

    //************************************************************************* map updated */
    showMap() {
      setTimeout(() => {
        //mapObject is a property that is part of leaflet
        this.$refs.limitMap.mapObject.invalidateSize();
      }, 100);

      // set display of map footer none
      $(".leaflet-control-attribution").hide();
    },

    getLatLong(event) {
      //console.log(event.latlng);
      this.center = [event.latlng.lat, event.latlng.lng];
      this.markerLatLng = [event.latlng.lat, event.latlng.lng];
    },
    //********************************************************************* get organiztion tree */
    GetOrganizationalStructureTree() {
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp +
            "OrganizationalStructure/GetOrganizationalStructureTree",
          JSON.stringify(""),
          config
        )
        .then((response) => {
          if (response.status == 200) {
            //console.log(response.data);
            this.structureList = response.data;
            this.structureListFillter = response.data;
          } else {
            // modal unsuccessful edit change
            (this.alertModal = true),
              (this.alertModalTitle = "خطایی رخ داده"),
              (this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
              (this.alertModalColor = "danger"),
              (this.alertModalButtonText = "تایید");
          }
        })
        .catch((response) => {
          if (response.status != 200) {
            // modal unsuccessful edit change
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          }
        });
    },

    //****************************************************************** select parrent */
    itemClick(node) {
      this.selectedParent = node.model.id;
      //console.log(this.selectedParent);
    },
    //********************************************************************* refresh datatable */
    refreshTable() {
      axios
        .get(Values.serverIp + "Point/Points")
        .then((response) => {
          console.log(response.data);
          this.points = response.data.data;
        })
        .catch((response) => {
          
          if (response.response.status == 403) {
            // modal unsuccessful edit change
            (this.alertModal = true),
              (this.showPage = false),
              (this.alertModalTitle = "عدم مجوز"),
              (this.alertModalText =
                "شما دارای مجوز دسترسی به این قسمت نمی باشید."),
              (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          } else if (response.response.status == 401) {
            //token has expired
            // modal unsuccessful edit change
            localStorage.removeItem("token");
            localStorage.removeItem("username");
            delete axios.defaults.headers.common["Authorization"];
          }
        });
    },

    //********************************************************************* datatable view action */
    viewAction(data) {
      // disable alet
      this.alert = false;
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp + "Point/GetPoint",
          JSON.stringify(data.pointId),
          config
        )
        .then((response) => {
          console.log(response.data.data);
          if (response.status == 200) {
            this.addModal = true;
            this.modalTitle = "اطلاعات نقطه";
            this.modalButtonSubmit = "تایید";

            this.showMap();

            // clear all red borders
            $(".form-control").removeAttr("style");

            this.structureList = JSON.parse(response.data.tree);

            // info
            this.info.id = response.data.data.pointId;
            this.info.name = response.data.data.pointName;

            this.info.description = response.data.data.description;
            this.setLayerValue(response.data.data.pointCategoryID);
            this.setPointStatusValue(response.data.data.statusId);

            this.selectedIcon = response.data.data.icon;

            // geo
            this.markerLatLng = [
              response.data.data.pointLat,
              response.data.data.pointLong,
            ];
            this.center = [
              response.data.data.pointLat,
              response.data.data.pointLong,
            ];
            
            this.info.radius= response.data.data.redius;
            this.info.pariority= response.data.data.pariority;
            // make all part to disabled
            $(".form-check, .form-control-file, .form-control").attr(
              "disabled",
              true
            );
            this.disableMultiselect = true;
          } else {
            // modal unsuccessful edit change
            (this.alertModal = true),
              (this.alertModalTitle = "خطایی رخ داده"),
              (this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
              (this.alertModalColor = "danger"),
              (this.alertModalButtonText = "تایید");
          }
        })
        .catch((response) => {
          if (response.status != 200) {
            // modal unsuccessful edit change
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          }
        });
    },

    //********************************************************************* datatable edit action */
    editAction(data) {
      this.restoreDefault();

      // disable alet
      this.alert = false;
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp + "Point/GetPointForUpdate",
          JSON.stringify(data.pointId),
          config
        )
        .then((response) => {
          if (response.status == 200) {
            console.log(response.data.data);
            this.addModal = true;
            this.modalTitle = "ویرایش نقطه";
            this.modalButtonSubmit = "اعمال";

            this.showMap();

            // clear all red borders
            $(".form-control").removeAttr("style");

            // make all part to enabled
            $(".form-check, .form-control-file, .form-control").attr(
              "disabled",
              false
            );
            this.disableMultiselect = false;

            this.structureList = JSON.parse(response.data.tree);
            this.selectedParent = response.data.data.organizationId;

            // info
            this.info.id = response.data.data.pointId;
            this.info.name = response.data.data.pointName;

            this.info.description = response.data.data.description;
            this.setLayerValue(response.data.data.pointCategoryID);
            this.setPointStatusValue(response.data.data.statusId);

            this.selectedIcon = response.data.data.icon;

            //geo
            this.markerLatLng = [
              response.data.data.pointLat,
              response.data.data.pointLong,
            ];
            //this.markerLatLng[1] = response.data.data.pointLong;
            this.center = [
              response.data.data.pointLat,
              response.data.data.pointLong,
            ];
            this.info.radius= response.data.data.redius;
            this.info.pariority= response.data.data.pariority;
          } else {
            // modal unsuccessful edit change
            (this.alertModal = true),
              (this.alertModalTitle = "خطایی رخ داده"),
              (this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
              (this.alertModalColor = "danger"),
              (this.alertModalButtonText = "تایید");
          }
        })
        .catch((response) => {
          if (response.status != 200) {
            // modal unsuccessful edit change
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          }
        });
    },

    //********************************************************************* datatable delete action */
    deleteAction(data) {
      console.log(data);
      (this.alertModal = true),
        (this.alertModalTitle = "حذف نقطه"),
        (this.alertModalText =
          "آیا از حذف نقطه " + data.pointName + " مطمئن هستید؟"),
        (this.alertModalColor = "warning"),
        (this.alertModalButtonText = "بله"),
        (this.pointId = data.pointId);
    },

    //*************************************** create table */
    createTable() {
      this.settingValues = [];
      for (var i = 0; i < this.SensorList.carSensorTypes.length; i++) {
        for (
          var j = 0;
          j < this.SensorList.carSensorTypes[i].values.length;
          j++
        ) {
          //console.log(this.SensorList.carSensorTypes[i].values[j].sensorIndex);
          this.settingValues.push({
            name: this.SensorList.carSensorTypes[i].sensorTypeName,
            type: this.SensorList.carSensorTypes[i].sensorType,
            index: this.SensorList.carSensorTypes[i].values[j].sensorIndex,
            indexName:
              this.SensorList.carSensorTypes[i].values[j].sensorIndexName,
            alarmUp: "",
            alarmDown: "",
          });
        }
      }
    },

    //********************************************************************* dataTable actions */
    handleAction(actionName, data) {
      if (actionName == "view") {
        this.viewAction(data);
      } else if (actionName == "edit") {
        this.editAction(data);
      } else if (actionName == "delete") {
        this.deleteAction(data);
      } else if (actionName == "sensor") {
        this.sensorAction(data);
      } else if (actionName == "sms") {
        this.smsAction2(data);
      } else if (actionName == "setting") {
        this.settingAction(data);
      }
    },

    //********************************************************************* edit and create point */
    submitForm() {
      // make all part to enabled
      $(".form-check, .form-control-file, .form-control").attr(
        "disabled",
        false
      );

      // clear all red borders
      $(".form-control, .needs-validation > .multiselect__tags").removeAttr(
        "style"
      );

      $(".form-control, .needs-validationSms > .multiselect__tags").removeAttr(
        "style"
      );

      $(
        ".form-control, .needs-validationSensor > .multiselect__tags"
      ).removeAttr("style");

      var forms = document.querySelectorAll(".needs-validation");
      let formValid = true;
      if (this.selectedParent != "") {
        for (var i = 0; i < forms[0].length; i++) {
          if (
            forms[0][i].type == "text" &&
            forms[0][i].required &&
            forms[0][i].value.length == 0
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "number" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "select-one" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "text" &&
            !forms[0][i].value.match(this.ipformat) &&
            !forms[0][i].value.length == 0 &&
            forms[0][i].maxLength == 15
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          }
        }
        if (this.info.status.value == "") {
          $(".needs-validation > .multiselect__tags").css(
            "border-color",
            "red"
          );
          formValid = false;
        }
        if (
          this.info.LayerValue.value == "" ||
          this.info.LayerValue.length == 0
        ) {
          $(".needs-validation > .multiselect__tags").css(
            "border-color",
            "red"
          );
          formValid = false;
        }

        let api = "";
        if (this.modalButtonSubmit == "اعمال") api = "EditPoint";
        else {
          api = "CreatePoint";
          this.info.id = null;
        }

        if (formValid == true) {
          console.log(this.info);
          axios
            .post(Values.serverIp + "Point/" + api, {
              //info
              pointId: this.info.id,
              pointName: this.info.name,

              statusId: JSON.parse(this.info.status.value),
              pointCategoryID: this.info.LayerValue.value,

              organizationId: this.selectedParent,
              description: this.info.description,

              //icon
              icon: this.selectedIcon,

              //geo
              pointLat: this.markerLatLng[0],
              pointLong: this.markerLatLng[1],

              redius: this.info.radius,
              pariority: this.info.pariority,
            })
            .then((response) => {
              if (response.status == 200) {
                //console.log(response.data);
                if (response.data == 1) {
                  this.addModal = false;
                  (this.alertModal = true),
                    (this.alertModalTitle = "تغییرات"),
                    (this.alertModalText = "تغییرات با موفقیت انجام شد."),
                    (this.alertModalColor = "success"),
                    (this.alertModalButtonText = "تایید"),
                    this.refreshTable();
                }  else {
                  // modal unsuccessful edit change
                  this.alertModal = true;
                  this.alertModalTitle = "خطایی رخ داده";
                  this.alertModalText =
                    "خطایی رخ داده!!! لطفا دوباره تلاش فرمایید.";
                  (this.alertModalColor = "warning"),
                    (this.alertModalButtonText = "تایید");
                }
                // modal successfuly
              } else {
                // modal unsuccessful edit change
                this.alertModal = true;
                this.alertModalTitle = "خطایی رخ داده";
                this.alertModalText =
                  "خطایی رخ داده!!! لطفا دوباره تلاش فرمایید.";
                (this.alertModalColor = "warning"),
                  (this.alertModalButtonText = "تایید");
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          // this.alert = true;
          // this.alertText = "لطفا تمامی موارد الزامی را وارد نمایید.";
          (this.alertModal = true),
            (this.alertModalTitle = "هشدار"),
            (this.alertModalText = "لطفا تمامی موارد الزامی را وارد نمایید."),
            (this.alertModalColor = "warning"),
            (this.alertModalButtonText = "تایید");
        }
      } else {
        // this.alert = true;
        // this.alertText = "لطفا سازمان را انتخاب نمایید.";
        (this.alertModal = true),
          (this.alertModalTitle = "هشدار"),
          (this.alertModalText = "لطفا سازمان را انتخاب نمایید."),
          (this.alertModalColor = "warning"),
          (this.alertModalButtonText = "تایید");
      }
    },

    //********************************************************************* delete point */
    deletePoint() {
      this.alertModal = false;
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp + "Point/DeletePoint",
          JSON.stringify(this.pointId),
          config
        )
        .then((response) => {
          if (response.status == 200 && response.data == "0") {
            (this.alertModal = true),
              (this.alertModalTitle = "حذف"),
              (this.alertModalText = "حذف نقطه با موفقیت انجام شد"),
              (this.alertModalColor = "success"),
              (this.alertModalButtonText = "تایید"),
              this.refreshTable();
          } else if (response.status == 200 && response.data == "1") {
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText = "خطا در ثبت اطلاعات در سرور.";
            this.alertModalColor = "danger";
            this.alertModalButtonText = "تایید";
          } else if (response.status == 200 && response.data == "2") {
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "این نقطه قابل حذف نیست زیرا تخصیص داده شده است.";
            this.alertModalColor = "danger";
            this.alertModalButtonText = "تایید";
          } else {
            //console.log("in else"),
            (this.alertModal = true),
              (this.alertModalTitle = "خطایی رخ داده"),
              (this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
              (this.alertModalColor = "danger"),
              (this.alertModalButtonText = "تایید");
          }
        })
        .catch((response) => {
          //console.log("in catch");
          if (response.status != 200) {
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            this.alertModalColor = "danger";
            this.alertModalButtonText = "تایید";
          }
        });
    },

    //********************************************************************* make form to default mode */
    restoreDefault() {
      // make all part to enabled
      $(".form-check, .form-control-file, .form-control").attr(
        "disabled",
        false
      );

      // clear all red borders
      $(".form-control, .needs-validation > .multiselect__tags").removeAttr(
        "style"
      );

      $(".form-control, .needs-validationSms > .multiselect__tags").removeAttr(
        "style"
      );

      $(
        ".form-control, .needs-validationSensor > .multiselect__tags"
      ).removeAttr("style");

      this.disableMultiselect = false;

      //info
      this.info = {
        id: "",
        name: "",
        status: { label: "فعال", value: 1 },
        description: "",
        LayerValue: [{ label: "", value: "" }],
        radius:"",
        pariority:"",
      };

      this.smsReception = {
        first: "",
        second: "",
        third: "",
        forth: "",
        fifth: "",
        sixth: "",
        updateTime: "---",
      };

      //icon
      (this.selectedIcon = "fa fa-car"),
        //geo
        (this.markerLatLng = [0, 0]);

      //simcard
      this.simcard.simCardNum = "";
      this.simcard.sendSmsStatus = false;
      this.simcard.simcardDataStatus = false;
      this.SimcardOprator = [];
      this.SimcardType = [];
      this.simcardUpdateTime = "";

      //wifi
      this.wifi.ipAddress = "";
      this.wifi.subnetMask = "";
      this.wifi.gateway = "";
      this.wifi.dns = "";
      this.wifi.ssid = "";
      this.wifi.password = "";
      this.wifi.active = false;
      this.wifi.updateTime = "---";

      //ethernet
      this.ethernet.ipAddress = "";
      this.ethernet.subnetMask = "";
      this.ethernet.gateway = "";
      this.ethernet.dns = "";
      this.ethernet.updateTime = "---";

      //serial Number
      this.serial = { serialTime: "", serialNumber: "" };

      //server Ip
      this.serverInfo.ipAddressGPRS = "";
      this.serverInfo.ipAddressWiFi = "";
      this.serverInfo.ipAddressEthernet = "";
      this.serverInfo.port = "";
      this.serverInfo.timeDistance = "";
      this.serverInfo.debugSystem = false;
      this.serverInfo.debugGsm = false;
      this.serverInfo.debugWifi = false;
      this.serverInfo.wifi = false;
      this.serverInfo.ethernet = false;
      this.serverInfo.gprs = false;
      this.serverInfo.updateTime = "---";

      //voice alarm
      this.voiceAlarmInfo.delay = "";
      this.voiceAlarmInfo.length = "";
      this.voiceAlarmInfo.voiceTemp = false;
      this.voiceAlarmInfo.smsTemp = false;
      this.voiceAlarmInfo.voiceHum = false;
      this.voiceAlarmInfo.smsHum = false;
      this.voiceAlarmInfo.updateTime = "---";

      //puls
      this.pulsInfo.first = "";
      this.pulsInfo.second = "";
      this.pulsInfo.updateTime = "---";

      this.dateTime = { dateTime: "", updateTime: "" };

      // sms
      this.settingValues = [];
      // this.settingValues[0].alarmUp = "";
      // this.settingValues[0].alarmDown = "";
      // this.settingValues[1].alarmUp = "";
      // this.settingValues[1].alarmDown = "";
      // this.settingValues[2].alarmUp = "";
      // this.settingValues[2].alarmDown = "";
      // this.settingValues[3].alarmUp = "";
      // this.settingValues[3].alarmDown = "";
      // this.settingValues[4].alarmUp = "";
      // this.settingValues[4].alarmDown = "";
      // this.settingValues[5].alarmUp = "";
      // this.settingValues[5].alarmDown = "";

      this.smsSettingInfo.reception = {
        value: "1",
        label: "گیرنده اول",
      };
      this.smsSettingInfo.receptionTemp = {
        value: "1",
        label: "گیرنده اول",
      };
      this.smsSettingInfo.receptionHum = {
        value: "1",
        label: "گیرنده اول",
      };
      //this.settingValues = [];
      this.smsSettingInfo.phoneNumber = "";

      this.smsSettingInfo.timeMaxTemp = "";
      this.smsSettingInfo.timeMinTemp = "";
      this.smsSettingInfo.timeMaxHum = "";
      this.smsSettingInfo.timeMinHum = "";
      this.smsSettingInfo.timeDisPower = "";
      this.smsSettingInfo.timeDisSensor = "";
      this.smsSettingInfo.active = false;
      this.smsSettingInfo.textSms = false;
      this.smsSettingInfo.puls = false;
      this.smsSettingInfo.updateTime = "---";

      // sensor
      this.indexValueSensor = { label: "", value: "" };
      this.typeValue = [];
      this.activeSensor = false;
      this.selectedSensors = [];

      this.settingValuesSensor = [];
      this.sensorUpdateTime = "";

      // disable alet
      this.alert = false;
    },

    //********************************************************************* set Point Status Value */
    setPointStatusValue(data) {
      for (var i = 0; i < this.StatusList.length; i++) {
        if (this.StatusList[i].value == data) {
          this.info.status.label = this.StatusList[i].label;
          this.info.status.value = this.StatusList[i].value;
        }
      }
    },

    //********************************************************************* set Model Value */
    setLayerValue(data) {
      for (var i = 0; i < this.LayerList.length; i++) {
        if (this.LayerList[i].value == data) {
          this.info.LayerValue = this.LayerList[i];
        }
      }
    },

    //*********************** report page */
    reportPage(data) {
      //router.push({ name: "JointReport", params: { whichReport: data } });

      let routeData = this.$router.resolve({
        name: "JointReport",
        query: { whichReport: data },
      });
      window.open(routeData.href, "_blank");
    },

    //***************************************************************** */
    setFillter(node) {
      // this.selectedParent = node.model.id;
      console.log(this.points);

      this.pointsFelltered = this.points.filter(function (el) {
        return el.organizationIdTree.includes(" " + node.model.id + " ");
        //el.statusId.includes(tempIds)
      });

      this.fillterActive = true;

      //console.log(this.pointsFelltered);
    },
  },
};
</script>

<style lang="css">
/* time picker style (start) */
.clock-picker__input {
  border: 1px solid gainsboro;
}
.clock-picker__input--error,
.clock-picker__input--error.clock-picker__input--has-value {
  color: #f44336;
}
.clock-picker__input--error .clock-picker__input,
.clock-picker__input--error.clock-picker__input--has-value
  .clock-picker__input {
  border-color: #f44336;
}
.clock-picker__input--has-value .clock-picker__input {
  border-color: #bec0c0;
}
.clock-picker__button {
  background: none;
  width: 24px;
  height: 24px;
  display: inline-block;
  border: 0;
  border-radius: 12px;
  line-height: 24px;
  padding: 0;
  margin: 0;
  cursor: pointer;
  color: #757575;
  font-weight: 500;
  font-size: 13px;
}
.clock-picker__button:hover {
  background-color: #f5f5f5;
}
.clock-picker__button:active {
  background-color: #ededed;
}
.clock-picker__button:focus {
  background-color: #e8e8e8;
}
.clock-picker__button--active,
.clock-picker__button--active:active,
.clock-picker__button--active:hover,
.clock-picker__button--active:focus {
  background-color: #a48bd1;
  color: #fff;
}
.clock-picker__button[disabled] {
  opacity: 0.4 !important;
  cursor: default;
}
.clock-picker__button[disabled],
.clock-picker__button[disabled]:active,
.clock-picker__button[disabled]:hover,
.clock-picker__button[disabled]:focus {
  background-color: #f5f5f5;
  color: #757575;
}

.clock-picker__dialog {
  display: none;
}
.clock-picker__dialog--active {
  display: block;
}
.clock-picker__dialog-drop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 200;
}
.clock-picker__dialog-body {
  direction: ltr;
  position: fixed;
  top: 50%;
  left: 50%;
  max-width: 100%;
  max-height: 100%;
  overflow: auto;
  width: 320px;
  margin: -235px -160px;
  background-color: #fff;
  z-index: 201;
  transform: scale(1);
  border-radius: 5px;
  overflow: auto;
}
.clock-picker__dialog-header {
  padding: 1.5rem 1.5rem;
  font-size: 2rem;
  text-align: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.clock-picker__dialog-header span:hover,
.clock-picker__dialog-header span:focus {
  cursor: pointer;
}
.clock-picker__dialog-content {
  position: relative;
  width: 100%;
  height: 280px;
  margin-top: 24px;
  margin-bottom: 24px;
}
.clock-picker__dialog-content .clock-picker__hours,
.clock-picker__dialog-content .clock-picker__minutes {
  position: absolute;
}
.clock-picker__dialog-actions {
  direction: rtl;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: row;
  flex-direction: row;
  border-top: 1px solid #f5f5f5;
  padding: 0.5rem;
}
.clock-picker__dialog-action {
  padding: 0 1rem;
  margin: 0;
  background: transparent;
  border: 0;
  -ms-flex: 1;
  flex: 1;
  font-size: 16px;
  font-weight: 500;
  line-height: 32px;
  display: inline-block;
  cursor: pointer;
}
.clock-picker__dialog-action:hover {
  background-color: #f5f5f5;
}
.clock-picker__dialog-action:focus {
  background-color: #ededed;
}
.clock-picker__dialog-action:active {
  background-color: #e6e6e6;
}
.clock-picker__dialog-action[disabled] {
  background-color: #f5f5f5;
  color: #e6e6e6;
}
.clock-picker__dialog-action[disabled]:hover,
.clock-picker__dialog-action[disabled]:focus,
.clock-picker__dialog-action[disabled]:active {
  cursor: not-allowed;
}
.clock-picker__dialog .scale-enter-active,
.clock-picker__dialog .scale-leave-active,
.clock-picker__dialog .fade-enter-active,
.clock-picker__dialog .fade-leave-active {
  transition: all 0.3s ease;
}
.clock-picker__dialog .scale-enter,
.clock-picker__dialog .scale-leave-active {
  opacity: 0;
  transform: scale(0);
}
.clock-picker__dialog .fade-enter,
.clock-picker__dialog .fade-leave-active {
  opacity: 0;
}

.clock-picker__hours {
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 280px;
}

.clock-picker__minutes {
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 280px;
}

/* add by alireza */
.clock-picker__input {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 0.25rem;
  -webkit-transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
}

.clock-picker__dialog-action[type="button"] {
  color: #39f !important;
}
.clock-picker__dialog-header {
  background-color: #39f !important;
}
/* time picker style (end) */
</style>
